import React from 'react';
import "./Logo.css";
import Flogo from "../../assets/logo.svg";

const Logo = () => {
    return (
        <div className="ftop">
            <div className="logo">
                <a href='/'><img src={Flogo} alt="LeadBust Logo" /></a>
            </div>
        </div>);
}

export default Logo;